module.exports = __webpack_public_path__ + "static/logoKopie-c06ca6f901a38d1d82e28b73d8705bc5.png";